import React from "react";
import { Grid, Typography } from "@mui/material";
import DetailRow from "../../pages/common-features/DetailRow";

interface ProvideConsentDetailsTabProps {
  partnerDetails: any[];
  partnerApplicationDetails: any[];
  isMobile: boolean;
}

const ProvideConsentDetailsTab: React.FC<ProvideConsentDetailsTabProps> = ({
  partnerDetails,
  partnerApplicationDetails,
  isMobile,
}) => {
  if (!partnerDetails || partnerDetails.length === 0)
    return (
      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary">
          No details available.
        </Typography>
      </Grid>
    );
  const capitalizeValue = (val: any) => {
    if (val === null || val === undefined) return "";

    return String(val)
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // Extract verification statuses
  const isMobileVerified =
    partnerDetails?.find(
      (f) => (f.name || "").toLowerCase() === "ismobileverified"
    )?.value === true;

  const isEmailVerified =
    partnerDetails?.find(
      (f) => (f.name || "").toLowerCase() === "isemailverified"
    )?.value === true;

  // Extract product from partnerApplicationDetails
  const productField = partnerApplicationDetails?.find(
    (f) => (f.name || "").toLowerCase() === "product"
  );

  return (
    <>
      {productField && (
        <Grid item xs={12} sm={6} md={3}>
          <DetailRow
            item={{
              label: productField.label,
              value: capitalizeValue(productField.value),
              isVerified: false,
            }}
          />
        </Grid>
      )}
      {partnerDetails?.map((field: any, subIndex: number) => {
        const skipNames = [
          "applicantid",
          "ismobileverified",
          "isemailverified",
        ];
        if (skipNames.includes((field.name || "").toLowerCase())) return null;

        // Determine if this field should be verified
        const fieldNameLower = (field.name || "").toLowerCase();
        let isVerified = false;

        if (fieldNameLower === "phone_number" && isMobileVerified) {
          isVerified = true;
        } else if (fieldNameLower === "email" && isEmailVerified) {
          isVerified = true;
        }

        return (
          <Grid item xs={12} sm={6} md={3} key={subIndex}>
            <DetailRow
              item={{
                label: field.label,
                value: capitalizeValue(field.value),
                isVerified: isVerified,
              }}
            />
          </Grid>
        );
      })}
    </>
  );
};

export default ProvideConsentDetailsTab;
